import { useMemo } from "react";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import Button from "../Buttons/Button";
import RichText from "../Utils/RichText";
import { stripHTML } from "../Utils/htmlStringUtils";

// Displays a published comment inline with its content and edit/delete action
// buttons. Fires `onEdit` and `onDelete` callbacks to the parent orchestrator.
//
const InlineCommentPublishedCard = ({ comment, onEdit, onDelete, isDeleting }) => {
  const t = useFormatMessage();

  const publishedLabel = t(intlMessages.published);
  const editLabel = t(intlMessages.edit);
  const deleteLabel = t(intlMessages.delete);

  const content = useMemo(() => {
    const text = stripHTML(comment.content);

    // Limit to 200 characters, as the user knows what he wrote.
    const excerpt = text.substring(0, 200);

    return excerpt.length < text.length ? `${excerpt}...` : excerpt;
  }, [comment.content]);

  return (
    <div className="box border border-success box-shadow bg-success-20 padding-sm margin-top-sm">
      <span className="text-success text-bold text-sm d-block margin-bottom-xs">
        {publishedLabel}
      </span>

      <RichText className="text-small text-muted margin-bottom-xs">{content}</RichText>

      <div className="d-flex">
        <Button
          type="button"
          className="btn btn-default btn-xs"
          onClick={onEdit}
          label={editLabel}
          iconClassName="fa fa-pencil"
        />

        <Button
          type="button"
          className="btn btn-danger btn-xs margin-left-xs"
          onClick={onDelete}
          disabled={isDeleting}
          label={deleteLabel}
          iconClassName="fa fa-trash"
        />
      </div>
    </div>
  );
};

export default InlineCommentPublishedCard;

const intlMessages = defineMessages({
  published: {
    id: "inlineCommentInput.published",
    defaultMessage: "Commentaire publié"
  },
  edit: {
    id: "inlineCommentInput.edit",
    defaultMessage: "Modifier"
  },
  delete: {
    id: "inlineCommentInput.delete",
    defaultMessage: "Supprimer"
  }
});
